module.exports = __webpack_public_path__ + "static/media/info.8100dbc4.svg";